module.exports = new __parcel__URL__("neon_gold_storage_level_11.70f6c5d4.png").toString();